module.exports = __webpack_public_path__ + "static/bri-stauss-ea08abf63547dce0c781f68d91c01056.jpg";